import type { FC } from "react";

import { assertUnreachable } from "@jti/commerce";
import type { AddressStored } from "@jti/fe-common";

import type { AddressHomeDeliveryFieldConfig } from "@checkout-v2/formFields";

import { AddressFormDialog } from "./components/AddressFormDialog";
import { AddressSelectionDialog } from "./components/AddressSelectionDialog";

export type State =
  | { type: "closed" }
  | {
      type: "address_selection";
      addresses: AddressStored[];
      preselectedAddress: AddressStored;
      onCreateNew: () => void;
      onConfirm: (address: AddressStored) => void;
      isOnSubmitLoading?: boolean;
    }
  | {
      type: "address_form";
      fieldConfig: AddressHomeDeliveryFieldConfig;
      immutableProvinceCode?: string;
      onAddressSaveClick: (address: AddressStored) => Promise<boolean | void>;
      onAddressFormCancelClick: () => void;
    };

type AtHomeAddressSelectionDialogProps = {
  state: State;
  shippingAddressErrorMessage?: string;
  onClose: () => void;
};

export const AtHomeAddressSelectionDialog: FC<AtHomeAddressSelectionDialogProps> = ({
  state,
  shippingAddressErrorMessage,
  onClose,
}: AtHomeAddressSelectionDialogProps) => {
  switch (state.type) {
    case "address_selection":
      return (
        <AddressSelectionDialog
          onClose={onClose}
          preselectedAddress={state.preselectedAddress}
          addresses={state.addresses}
          onCreateNew={state.onCreateNew}
          onConfirm={state.onConfirm}
          isOnSubmitLoading={state.isOnSubmitLoading}
        />
      );
    case "address_form":
      return (
        <AddressFormDialog
          onAddressSaveClick={state.onAddressSaveClick}
          fieldConfig={state.fieldConfig}
          immutableProvinceCode={state.immutableProvinceCode}
          shippingAddressErrorMessage={shippingAddressErrorMessage}
          onAddressFormCancelClick={state.onAddressFormCancelClick}
          onClose={onClose}
        />
      );
    case "closed":
      return null;
    default:
      return assertUnreachable(state);
  }
};
